<template>
  <div class="divider">
    <label class="contentLabel" for="textColor">Text Color</label>
    <div class="color-container">
      <input type="color" id="textColor" name="textC" v-model="textColor" />
      <span v-if="textColor" class="material-symbols-outlined reset-color" @click="resetColor">refresh</span>
      <div v-else class="add-color-overlay">+</div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['sharedData'],
    computed:{
    textColor: {
      get() {
        return this.sharedData?.data?.style?.color || '';
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.color = value;
      },
    },
    },
    methods: {
        resetColor() {
            this.textColor = null;
        }
    }
}
</script>

<style>
    @import '../../../styles/addComponents.css';
</style>